import FormAutoComplete, {FormAutoCompleteItem} from "./FormAutoComplete";
import FormGroup from "./FormGroup";
import {platforms} from "../../data/platforms";
import FormDateRange from "./FormDateRange";
import React, {useEffect, useMemo} from "react";
import deDELocale from "date-fns/locale/de";
import enUSLocale from "date-fns/locale/en-US";
import useOrganizations from "../../hooks/UseOrganizations";
import {useTranslation} from "react-i18next";
import {allReports, platformReports} from "../../data/reports";
import {Typography} from "@mui/material";

interface ReportBasicParametersProps {
  values: Record<string, any>;
  changeForm: (name: string, value: any) => void;
  changePlatform: (name: string, value: FormAutoCompleteItem | null) => void;
  changeReport: (name: string, value: FormAutoCompleteItem | null) => void;
}

export default function BasicReportParameters({
  values, changeForm, changePlatform, changeReport
}: ReportBasicParametersProps) {
  const {i18n} = useTranslation();
  const organizations = useOrganizations();

  const transposedOrgs: FormAutoCompleteItem[] = useMemo(() => {
    return organizations ? organizations.map(o => ({value: o.id, label: `${o.name} (${o.id})`})) : []
  }, [organizations]);

  const currentLocale = i18n.resolvedLanguage === "de-DE" ? deDELocale : enUSLocale;
  const selectedPlatform = values.platform && values.platform.value;
  const availableReports = platformReports[selectedPlatform] ?? allReports;

  // select first org when loading orgs has finished
  useEffect(() => {
    if (transposedOrgs.length === 0) return;
    changeForm("customer_id", transposedOrgs[0]);
  }, [transposedOrgs]); // eslint-disable-line

  return <FormGroup title={<div>Report<br /><Typography variant="caption">All fields marked with * are mandatory.</Typography></div>}>
    <FormAutoComplete
      name="customer_id"
      label="Organization"
      values={values}
      onChange={changeForm}
      items={transposedOrgs}
      required/>

    <FormAutoComplete
      name="platform"
      label="Platform"
      values={values}
      onChange={changePlatform}
      items={platforms} />

    <FormAutoComplete
      name="report"
      label={"Report"}
      values={values} onChange={changeReport}
      items={availableReports}
      required/>

    <FormDateRange
      suffix={"_date"}
      locale={currentLocale}
      labels={['From', 'To']}
      values={values}
      onChange={changeForm}
      required/>
  </FormGroup>
}
